var exports = {
  "Zd": "AuthIdentifierFirstStep.module__form___RDNFMG",
  "aJ": "AuthIdentifierFirstStep.module__formAfterHeader___RDNFMG",
  "h_": "AuthIdentifierFirstStep.module__description___RDNFMG",
  "Uy": "AuthIdentifierFirstStep.module__quietActions___RDNFMG",
  "uX": "AuthIdentifierFirstStep.module__textButton___RDNFMG",
  "aK": "AuthIdentifierFirstStep.module__hint___RDNFMG",
  "qx": "AuthIdentifierFirstStep.module__hintError___RDNFMG",
  "Vo": "AuthIdentifierFirstStep.module__alternatives___RDNFMG",
};

module.exports = exports;
